import React from 'react';
import { motion } from 'framer-motion';
import stainingResponder from '../img/Staining - Responder.png';
import stainingNonResponder from '../img/Staining - Non responder.png';
import legendResponder from '../img/Légende Responder Non responder.png';

const WorkflowSection = () => {
  return (
    <section id="workflow" className="py-20 md:py-32 relative bg-white">
      <div className="container mx-auto px-6">
        
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-ninsun-text mb-6 tracking-tight">
            A predictive test adapted to current testing&nbsp;workflows
          </h2>
          <p className="text-xl text-ninsun-muted leading-relaxed font-semibold">
            NinStem Lung Test Kit specifically quantifies cancer stem cells (CSCs) abundance within tumor microenvironment.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-16">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <ul className="space-y-6">
              <li className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-ninsun-gold/10 flex items-center justify-center flex-shrink-0 text-ninsun-gold font-bold font-mono">1</div>
                <p className="text-ninsun-muted pt-1">The assay is based on a regular immuno-histochemistry assay on formalin-fixed paraffin embedded (FFPE) tissues from biopsy or surgical resection, an assay similar to PD-L1 testing.</p>
              </li>
              <li className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-ninsun-gold/10 flex items-center justify-center flex-shrink-0 text-ninsun-gold font-bold font-mono">2</div>
                <p className="text-ninsun-muted pt-1">CSCs are specifically labelled using patented NinStem Lung Kit reagent and revealed with standard HRP protocol from autostainers vendors.</p>
              </li>
              <li className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-ninsun-gold/10 flex items-center justify-center flex-shrink-0 text-ninsun-gold font-bold font-mono">3</div>
                <p className="text-ninsun-muted pt-1">The entire procedure is fully automated on standard autostainers used in clinical laboratories. The process takes 2 hours.</p>
              </li>
              <li className="flex gap-4">
                <div className="w-8 h-8 rounded-full bg-ninsun-gold/10 flex items-center justify-center flex-shrink-0 text-ninsun-gold font-bold font-mono">4</div>
                <p className="text-ninsun-muted pt-1">Quantification of staining within the tumor tissue is performed by the pathologist or by an automated AI-based image analysis application. Interpretation is a simple, cut-off based, yes/no answer.</p>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col items-center">
                <img src={stainingResponder} alt="Staining - Responder" className="rounded-lg shadow-sm border border-gray-200 mb-2 w-full h-auto" />
              </div>
              <div className="flex flex-col items-center">
                <img src={stainingNonResponder} alt="Staining - Non Responder" className="rounded-lg shadow-sm border border-gray-200 mb-2 w-full h-auto" />
              </div>
            </div>
            <div className="flex justify-center mt-4">
              <img src={legendResponder} alt="Legend Responder vs Non Responder" className="max-w-[300px] w-full" />
            </div>
          </motion.div>
        </div>

        <div className="max-w-4xl mx-auto text-center pt-2 pb-16">
          <p className="text-ninsun-muted font-bold">
            You are a pathologist and want to learn more about implementing our test in your clinical routine? <br className="hidden md:block" />
            <a href="mailto:contact@ninsun-biotech.com" className="text-ninsun-gold hover:underline font-bold">Contact us</a>
          </p>
        </div>

        <motion.div
          className="bg-ninsun-surface border border-gray-200 rounded-xl p-8 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="text-ninsun-muted text-sm font-mono uppercase tracking-widest mb-4">Regulatory Notice</p>
          <p className="text-ninsun-text font-bold">This product is not yet certified or approved for clinical diagnostic use.</p>
        </motion.div>

      </div>
    </section>
  );
};

export default WorkflowSection;